import { Button } from '@/components/ui/button';
import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/terms')({
    component: TermsPage,
});

function TermsPage() {
    return (
        <div className="min-h-screen bg-emerald-50 text-emerald-950">
            <header className="border-b border-emerald-100 bg-white/80">
                <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-4 py-5">
                    <Link to="/" className="flex items-center gap-3">
                        <img
                            src="https://res.cloudinary.com/flannery38/image/upload/v1771973120/stockwright/logo.svg"
                            alt="Stockwright"
                            className="h-6"
                        />
                    </Link>
                    <div className="flex items-center gap-3">
                        <Link
                            to="/faq"
                            className="text-sm text-emerald-800/80 hover:text-emerald-900"
                        >
                            FAQ
                        </Link>
                        <Link
                            to="/security"
                            className="text-sm text-emerald-800/80 hover:text-emerald-900"
                        >
                            Security
                        </Link>
                        <Button asChild className="bg-emerald-700 text-white">
                            <Link to="/auth" search={{ mode: 'signup' }}>
                                Start Free Trial
                            </Link>
                        </Button>
                    </div>
                </div>
            </header>

            <main className="mx-auto w-full max-w-5xl px-4 py-12">
                <div className="mb-10">
                    <p className="text-xs font-semibold uppercase tracking-wide text-emerald-600/80">
                        Terms
                    </p>
                    <h1 className="mt-2 text-3xl font-semibold">
                        Terms of service
                    </h1>
                    <p className="mt-3 max-w-2xl text-sm text-emerald-900/70">
                        These terms govern use of Stockwright. By using the
                        product, you agree to them.
                    </p>
                </div>

                <div className="grid gap-6">
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            Account and access
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            You are responsible for your account credentials
                            and activity. Use the product only for lawful
                            business purposes.
                        </p>
                    </section>
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">Billing</h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            Subscriptions renew automatically unless canceled.
                            Pricing and trial terms are shown at checkout and
                            may change with notice.
                        </p>
                    </section>
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            Data and content
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            You retain ownership of your data. You grant us
                            permission to process it to provide the service.
                        </p>
                    </section>
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            Acceptable use
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            Do not misuse the product, interfere with service
                            operations, or attempt unauthorized access.
                        </p>
                    </section>
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            Termination
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            You can cancel anytime. We may suspend access for
                            violations or abuse.
                        </p>
                    </section>
                </div>
            </main>
        </div>
    );
}
